import {clinicPatientsSingleAccountStateUniqueIdentifier} from './dashboard-clinic-patients-single-account.model';
import {SharedPatientData, UserSharedAccountData} from '../../symbols/dashboard-clinic-patients.symbols';
import {UnknownError} from '../../../shared/symbols';
import {User} from '../../../auth/symbols';

export class LoadSelectedScanAccount {
  static readonly type = `${clinicPatientsSingleAccountStateUniqueIdentifier} ${LoadSelectedScanAccount.name}`;

  constructor(public patientId: User[`uid`]) {}
}

export class LoadSelectedScanAccountSuccess {
  static readonly type = `${clinicPatientsSingleAccountStateUniqueIdentifier} ${LoadSelectedScanAccountSuccess.name}`;

  constructor(public patientData: UserSharedAccountData) {}
}

export class LoadSelectedScanAccountFail {
  static readonly type = `${clinicPatientsSingleAccountStateUniqueIdentifier} ${LoadSelectedScanAccountFail.name}`;

  constructor(public error: UnknownError) {}
}

export class EditPatient {
  static readonly type = `${clinicPatientsSingleAccountStateUniqueIdentifier} ${EditPatient.name}`;

  constructor(public patientId: User[`uid`], public patientData: SharedPatientData) {}
}

export class EditPatientSuccess {
  static readonly type = `${clinicPatientsSingleAccountStateUniqueIdentifier} ${EditPatientSuccess.name}`;

  constructor(public patientId: User[`uid`], public patientData: SharedPatientData) {}
}

export class EditPatientFail {
  static readonly type = `${clinicPatientsSingleAccountStateUniqueIdentifier} ${EditPatientFail.name}`;

  constructor(public error: UnknownError) {}
}

export class LoadManagePatientAccount {
  static readonly type = `${clinicPatientsSingleAccountStateUniqueIdentifier} ${LoadManagePatientAccount.name}`;

  constructor(public patientId: User[`uid`]) {}
}

export class LoadManagePatientAccountSuccess {
  static readonly type = `${clinicPatientsSingleAccountStateUniqueIdentifier} ${LoadManagePatientAccountSuccess.name}`;

  constructor(public patientData: UserSharedAccountData) {}
}

export class LoadManagePatientAccountFail {
  static readonly type = `${clinicPatientsSingleAccountStateUniqueIdentifier} ${LoadManagePatientAccountFail.name}`;

  constructor(public error: UnknownError) {}
}

export class ResetManagePatientAccount {
  static readonly type = `${clinicPatientsSingleAccountStateUniqueIdentifier} ${ResetManagePatientAccount.name}`;
}
